import Icon from '../components/Icon.vue'

Icon.register({"ellipsis-h":{"width":512,"height":512,"paths":[{"d":"M328 256C328 295.8 295.8 328 256 328S184 295.8 184 256 216.2 184 256 184 328 216.2 328 256zM432 184C392.2 184 360 216.2 360 256S392.2 328 432 328 504 295.8 504 256 471.8 184 432 184zM80 184C40.2 184 8 216.2 8 256S40.2 328 80 328 152 295.8 152 256 119.8 184 80 184z"}]}})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/ellipsis-h.js
// module id = bWbu
// module chunks = 0